var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12C10 11.8674 10.0527 11.7402 10.1464 11.6464C10.2402 11.5527 10.3674 11.5 10.5 11.5H21.5C21.6326 11.5 21.7598 11.5527 21.8536 11.6464C21.9473 11.7402 22 11.8674 22 12C22 12.1326 21.9473 12.2598 21.8536 12.3536C21.7598 12.4473 21.6326 12.5 21.5 12.5H10.5C10.3674 12.5 10.2402 12.4473 10.1464 12.3536C10.0527 12.2598 10 12.1326 10 12ZM21.5 14H10.5C10.3674 14 10.2402 14.0527 10.1464 14.1464C10.0527 14.2402 10 14.3674 10 14.5C10 14.6326 10.0527 14.7598 10.1464 14.8536C10.2402 14.9473 10.3674 15 10.5 15H21.5C21.6326 15 21.7598 14.9473 21.8536 14.8536C21.9473 14.7598 22 14.6326 22 14.5C22 14.3674 21.9473 14.2402 21.8536 14.1464C21.7598 14.0527 21.6326 14 21.5 14ZM21.5 16.5H10.5C10.3674 16.5 10.2402 16.5527 10.1464 16.6464C10.0527 16.7402 10 16.8674 10 17C10 17.1326 10.0527 17.2598 10.1464 17.3536C10.2402 17.4473 10.3674 17.5 10.5 17.5H21.5C21.6326 17.5 21.7598 17.4473 21.8536 17.3536C21.9473 17.2598 22 17.1326 22 17C22 16.8674 21.9473 16.7402 21.8536 16.6464C21.7598 16.5527 21.6326 16.5 21.5 16.5ZM21.5 19H10.5C10.3674 19 10.2402 19.0527 10.1464 19.1464C10.0527 19.2402 10 19.3674 10 19.5C10 19.6326 10.0527 19.7598 10.1464 19.8536C10.2402 19.9473 10.3674 20 10.5 20H21.5C21.6326 20 21.7598 19.9473 21.8536 19.8536C21.9473 19.7598 22 19.6326 22 19.5C22 19.3674 21.9473 19.2402 21.8536 19.1464C21.7598 19.0527 21.6326 19 21.5 19Z",
    fill: "url(#paint0_linear_7282_59)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7282_59",
    x1: 10,
    y1: 15.75,
    x2: 22,
    y2: 15.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CC5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0A74FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D57BC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListGradient);
export default __webpack_public_path__ + "static/media/list-gradient.8a09ad6e6e9ab04e59534c1c6cee39f9.svg";
export { ForwardRef as ReactComponent };